export default "__VITE_ASSET__DRHKM2D8__"